// extracted by mini-css-extract-plugin
export default {"cls1":"d0T4iMil9K__3ZUWH01P","cls2":"FWj5ovaKuNPYXHCtHpim d0T4iMil9K__3ZUWH01P"};